const SportBookOdds = ({
  res,
  parly,
  conditionShowPositon,
  conditionPosition,
  newPosition,
}) => {
  let showPosition =
    (!parly && !isNaN(Math.abs(newPosition) > 0) && conditionPosition) ||
    (!parly && conditionShowPositon);
  return (
    <>
      <p data-v-fae226aa className="s-text-11px s-text-black-900 s-min-h-10px">
        {res?.odds}
      </p>

      {showPosition && (
        <div
          data-v-fae226aa
          className="s-rounded-full s-px-2 s-mt-0.5 s-bg-white s-bg-opacity-40"
        >
          <div
            data-v-fae226aa
            className="s-text-12px s-leading-150 s-flex"
            data-testid="forecast"
          >
            {Math.abs(res?.position) > 0 && (
              <span
                className={`s-flex s-items-center s-text-forecast-${
                  res?.position > 0 ? "up" : "down"
                }-text`}
                data-testid="estimate-forecast"
              >
                {res?.position > 0
                  ? Math.abs(res?.position).toFixed(2)
                  : `( ${Math.abs(res?.position).toFixed(2)} )`}
              </span>
            )}
            {!parly &&
              !isNaN(Math.abs(newPosition) > 0) &&
              conditionPosition && (
                <span
                  className={`s-flex s-items-center s-text-forecast-${
                    newPosition > 0 ? "up" : "down"
                  }-text`}
                  data-testid="estimate-forecast"
                >
                  <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                  {newPosition > 0
                    ? Math.abs(newPosition).toFixed(2)
                    : `( ${Math.abs(newPosition).toFixed(2)} )`}
                </span>
              )}
          </div>
        </div>
      )}
    </>
  );
};

export default SportBookOdds;
